<template>
  <div class='slides edit container'>Yo
    <div class="slideStatus container row" :class="{ 'dirty': isDirty }"></div>
    <small class="text-muted">{{ $route.name }}</small>
    <small v-if="!isLoaded"> | loading</small>
    <small v-if="list !== undefined && isLoaded" class="text-muted"> | list:
      <a href="#" @click.prevent.stop="$router.push({ path: `/lists/edit/${list._id}` })" >{{ list.name }}</a>
    </small>
    <small v-if="list === undefined && isLoaded" class="text-muted"> | <b>invalid list id</b> </small>
    <small v-if="listIndex > -1 && isLoaded" class="text-muted"> - index: <b>{{ listIndex }}</b></small>
    <small v-if="!isDirty" class="text-muted"> | <span style="color:green">synced</span></small>
    <small v-if="isDirty" class="text-muted"> | <span style="color:red">dirty</span></small>

    <h1 v-if="isLoaded" class="title">
      {{ slide.name }}
    </h1>
    <ul class="nav nav-tabs" style="margin-bottom:10px">
      <li class="nav-item">
        <a class="nav-link" :class="{ 'active': view === 'forms' }" href="#" @click.prevent.stop="view ='forms'">Forms</a>
      </li>
      <li class="nav-item">
        <a class="nav-link" :class="{ 'active': view === 'json' }" href="#" @click.prevent.stop="view = 'json'">Raw Json</a>
      </li>
    </ul>
    <div class="row" v-if="validationErrors.length">
        <b>Please correct the following error(s):</b>
        <ul>
          <li v-for="(error, i) in validationErrors" :key="i">{{ error }}</li>
        </ul>
    </div>
    <div v-if="isLoaded" class="row">
      <div  class="col-8">

        <div v-if="view==='json'" class="row">
          <div class="col-9">
            <EditJson :slide="slide" :rows="30"/>
          </div>
          <div class="col-3" ng-hide="list">
            <button type="button" class="btn btn-primary" @click.prevent.stop="onSaveClicked">Save</button>
            <!-- <button type="button" class="btn btn-primary" @click.prevent.stop="onTestClicked">TEST</button> -->
            <div style="margin-top:20px;">
              <h5>Available Categories:</h5>
              <ul>
                <li v-for="option in $config.slides.categories" :key="option.value">
                  {{ option.value }}
                </li>
              </ul>
              <h5>Available Templates:</h5>
              <ul>
                <li v-for="(value, key) in $config.slides.templates" :key="key">
                  {{ key }}
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div v-if="view==='forms'" class="row">
          <div class="col-6">
            <input type="text" class="form-control" v-model="slideName"/>
            <small class="text-muted">Slide Title</small>
          </div>
          <div v-if="slide.hasOwnProperty('category')" class="col-3">
            <select class="form-control" v-model="slide.category">
              <option v-for="option in $config.slides.categories" v-bind:value="option.value" :key="option.value">
                {{ option.name }}
              </option>
            </select>
            <small class="text-muted">Content Type</small>
          </div>
          <div class="col-3">
            <select class="form-control" v-model="slideStatus">
              <option v-for="(value, key) in $config.slides.status" v-bind:value="key" :key="key">{{ value }}</option>
            </select>
            <small class="text-muted">Status</small>
          </div>
          <div class="col-3" ng-hide="list">
            <button type="button" class="btn btn-primary" @click.prevent.stop="onSaveClicked">Save</button>
            <!-- <button type="button" class="btn btn-primary" @click.prevent.stop="onTestClicked">Test</button> -->
          </div>
          <div v-if="({}).hasOwnProperty.call(slide, 'introDuration')" class="col-3">
            <input type="number" class="form-control" v-model.number="slide.introDuration">
            <small class="text-muted">Intro Duration</small>
          </div>
          <div v-if="({}).hasOwnProperty.call(slide, 'duration')" class="col-3">
            <input type="number" class="form-control" v-model.number="slide.duration">
            <small class="text-muted">Duration</small>
          </div>
          <div v-if="({}).hasOwnProperty.call(slide, 'outroDuration')" class="col-3">
            <input type="number" class="form-control" v-model.number="slide.outroDuration">
            <small class="text-muted">Outro Duration</small>
          </div>
        </div>
        <hr v-if="view==='forms'" />
        <div v-if="view==='forms'" class="row">
          <div class="col-6">
            <select class="form-control" v-model="slideTemplate">
              <option v-for="(value, key) in $config.slides.templates" :value="key" :key="key">
                {{ value.name }}
              </option>
            </select>
            <small class="text-muted">Slide Template</small>
          </div>
        </div>
        <hr v-if="view==='forms'" />
        <component v-if="view==='forms'" :is="templateComponent" :settings="templateSettings" />

      </div>
      <div class="col-4">
        <pre style="overflow:visible;background-color:#eee">{{ slide }}</pre>
      </div>
    </div><!-- end row -->
  </div>
</template>

<script>

import { SLIDES_NAMESPACE, SET_SLIDE, SET_SLIDE_MODULES, SET_SLIDE_PROPERTY, SYNCED, SET_DIRTY, ADD_VALIDATION_ERROR, EMTPY_VALIDATION_ERRORS } from 'rph-slides-vue/src/store/slides.mutation-types.js'
import { tokenMixin } from 'rph-slides-vue/src/mixins/tokenMixin.js'
import { mapState, mapGetters, mapMutations } from 'vuex'
import { eventBus } from 'rph-slides-vue/src/util/eventBus.js'
// import JsonModule from './../../components/slides/modules/JsonModule.vue'
import EditJson from 'rph-slides-vue/src/components/EditJson.vue'
// import RandomSlideFromListModule from '@/components/slides/modules/RandomSlideFromListModule.vue'

export default {
  name: 'slidesEdit',
  mixins: [tokenMixin],
  // adding categories/templates here because they are static / not reactive
  components: {
    EditJson
  },
  data () {
    return {
      listIndex: -1,
      listId: '',
      slideId: '',
      view: 'forms',
      slideOrigString: ''
    }
  },
  computed: {
    isDirty () {
      if (this.$route.name === 'slide/edit') {
        return this.$store.getters[SLIDES_NAMESPACE + '/isDirty'](this.listId + this.slideId)
      } else {
        return true
      }
    },
    isLoaded () {
      if (this.$route.name === 'slide/edit' && this.$store.state[SLIDES_NAMESPACE].lists.length < 1) {
        return false
      } else {
        return true
      }
    },
    slide: {
      get () {
        return this.$store.state[SLIDES_NAMESPACE].slide
      },
      set (slide) {
        this[SET_SLIDE](slide)
      }
    },
    slideName: {
      get () {
        return this.slide.name
      },
      set (val) {
        this[SET_SLIDE_PROPERTY]({ property: 'name', val })
      }
    },
    slideStatus: {
      get () {
        return this.slide.status
      },
      set (val) {
        this[SET_SLIDE_PROPERTY]({ property: 'status', val })
      }
    },
    slideTemplate: {
      get () {
        return this.slide.template
      },
      set (val) {
        this[SET_SLIDE_PROPERTY]({ property: 'template', val })
      }
    },
    templateComponent () {
      let comp = 'template-general'
      // console.log('XXXX  this.$config.slides.templates:', this.$config.slides.templates)
      if (Object.prototype.hasOwnProperty.call(this.$config.slides.templates, this.slide.template)) {
        comp = this.$config.slides.templates[this.slide.template].template
      }
      return comp
    },
    templateSettings () {
      let settings = []
      if (Object.prototype.hasOwnProperty.call(this.$config.slides.templates, this.slide.template) &&
        Object.prototype.hasOwnProperty.call(this.$config.slides.templates[this.slide.template], 'settings')) {
        settings = JSON.parse(JSON.stringify(this.$config.slides.templates[this.slide.template].settings))
      }
      return settings
    },
    list () {
      return this.getListById(this.listId)
    },
    ...mapState(SLIDES_NAMESPACE, ['validationErrors', 'selectedPlayerId', 'players']),
    ...mapGetters(SLIDES_NAMESPACE, ['selectedListId', 'getListById'])
  },
  watch: {
    slide: {
      handler (val, oldVal) {
        // console.log('watch slide edit. watch: ', val.watch, oldVal.watch)
        if (val.dev && oldVal.dev && val.dev.watch && oldVal.dev.watch && this.$route.name !== 'slide/create') {
          // console.log('watch slide edit. watch: ', this.slideOrigString === JSON.stringify(this.slide), this.slideOrigString, JSON.stringify(this.slide))
          if (this.slideOrigString === JSON.stringify(this.slide)) {
            this.$store.commit(SLIDES_NAMESPACE + '/' + SYNCED, this.listId)
            this.$store.commit(SLIDES_NAMESPACE + '/' + SYNCED, this.listId + this.slideId)
          } else {
            this.setDirty()
          }
        }
      },
      deep: true
    },
    'slide.template' (val, oldVal) {
      // console.log('slide/edit watch template: ', val, oldVal)
      if (this.view === 'json') return
      if (oldVal === '' && this.$route.name === 'slide/edit') return
      if (oldVal === undefined && this.$route.name === 'slide/edit') return

      if (Object.prototype.hasOwnProperty.call(this.$config.slides.templates, val)) {
        const template = this.$config.slides.templates[val]
        const defaultModel = JSON.parse(JSON.stringify(template.defaultModel))

        if (Array.isArray(defaultModel)) {
          console.log('slide/edit watch template - defaultModel/array: ', defaultModel)
          this[SET_SLIDE_MODULES](defaultModel)
        } else {
          console.log('slide/edit watch template - defaultModel/object: ', defaultModel)
          for (const property in defaultModel) {
            console.log('slide/edit watch template - defaultModel/object-property: ', property)
            this[SET_SLIDE_PROPERTY]({ property, val: defaultModel[property] })
          }
        }
      }
      // else {
      //   return [{ type: 'template not found', template: templateId }]
      // }
    },
    isLoaded: function (val, oldVal) {
      if (this.$route.name === 'slide/edit' && val === true && oldVal === false) {
        this.setSlideData()
      }
    }
  },
  created: function () {
    eventBus.$on('validate', this.onValidate)
    this.init()
  },
  methods: {
    ...mapMutations(SLIDES_NAMESPACE, [ADD_VALIDATION_ERROR, EMTPY_VALIDATION_ERRORS, SET_SLIDE, SET_SLIDE_MODULES, SET_SLIDE_PROPERTY]),
    init (newSlide) {
      // console.log(this.$route.name, 'created')
      // resetx
      // for (var k in this.$options.templates) {
      //   delete this.$options.templates[k].temp
      // }
      if (this.$route.name === 'slide/create') {
        // console.log(this.$route.name, 'created', this.$route.params)
        this.listId = this.$route.params.listId
        this.listIndex = this.$route.params.index
        const slide = JSON.parse(JSON.stringify({ ...this.$config.slides.defaultModel, ...{ dev: { watch: false } } }))
        slide.listId = this.listId
        slide.dev = { watch: true }
        this.slide = slide
        this.slideOrigString = JSON.stringify(this.slide)
        // if (this.slide.created_at && typeof this.slide.created_at === 'string') {
        //   this.slide.created_at = new Date(this.slide.created_at)
        // }
        // console.log('created: ',this.$route.name, this.listId, this.listIndex)
      } else if (this.$route.name === 'slide/edit') {
        // console.log(this.$route.name, 'edit', this.slide.watch)
        this.listId = this.$route.params.listId
        this.slideId = this.$route.params.slideId
        // console.log('set this.slideId:', this.slideId)
        if (this.isLoaded) {
          this.setSlideData(newSlide)
        }
      } else {
        // console.log('wrong route name: ', this.$route.name)
      }
    },
    setDirty () {
      // console.log(this.$route.name, 'set dirty')
      this.$store.commit(SLIDES_NAMESPACE + '/' + SET_DIRTY, this.listId)
      this.$store.commit(SLIDES_NAMESPACE + '/' + SET_DIRTY, this.listId + this.slideId)
    },
    setSlideData: function (slide) {
      if (!slide) {
        slide = this.$store.getters[SLIDES_NAMESPACE + '/getSlideFromListById']({ listId: this.listId, slideId: this.slideId })
      }
      this.$store.commit(SLIDES_NAMESPACE + '/' + SYNCED, this.listId)
      this.$store.commit(SLIDES_NAMESPACE + '/' + SYNCED, this.listId + this.slideId)
      this.slide = JSON.parse(JSON.stringify(slide))
      this.slide.dev = { watch: true }
      this.slideOrigString = JSON.stringify(this.slide)
      // console.log(this.$route.name, 'setSlideData', this.slide.watch)
    },
    // getDefaultModuleModel: function (templateId) {
    //   // let modules = []
    //   if (Object.prototype.hasOwnProperty.call(this.$config.slides.templates, templateId)) {
    //     // for(var i = 0; i < this.$options.templates[templateId].components.length; i++) {
    //     //   modules.push( this.$options.templates[templateId].components[i].defaultModel )
    //     // }
    //     // if (Object.prototype.hasOwnProperty.call(this.$options.templates[templateId], 'temp')) {
    //     //   return this.$options.templates[templateId].temp
    //     // } else {
    //     return JSON.parse(JSON.stringify(this.$config.slides.templates[templateId].defaultModel))
    //     // }
    //   }
    //   return [{ type: 'template not found', template: templateId }]
    // },
    createObjectId: function objectId () {
      return this.hex(Date.now() / 1000) +
        ' '.repeat(16).replace(/./g, () => this.hex(Math.random() * 16))
    },
    hex: function (value) {
      return Math.floor(value).toString(16)
    },
    // onTestClicked: function () {
    //   // console.log('test slide', this.selectedPlayerId, this.slide)
    //   this.emptyValidationErrors()
    //   eventBus.$emit('validate')
    //   if (this.validationErrors.length < 1) {
    //     // console.log('Validation successful.')
    //     this.$socket.emit('/players/slides/test', this.tokenize({ playerId: this.selectedPlayerId, slide: this.slide }))
    //   }
    // },
    onSaveClicked: function () {
      this.emptyValidationErrors()
      eventBus.$emit('validate')
      if (this.validationErrors.length < 1) {
        // console.log('Validation successful.')
        if (!Object.prototype.hasOwnProperty.call(this.slide, 'id')) {
          this.slide.id = this.createObjectId()
        }
        this.slide.dev.watch = false
        this.slide.dev.loading = 'send off to server'

        const slideCopy = JSON.parse(JSON.stringify(this.slide))
        delete slideCopy.dev

        if (slideCopy.created_at && typeof slideCopy.created_at === 'string') {
          slideCopy.created_at = new Date(slideCopy.created_at)
        }
        // console.log(slideCopy)

        if (this.$route.name === 'slide/create') {
          const listId = this.listId || slideCopy.listId

          this.$socket.emit('/lists/slides/create', this.tokenize({ index: this.listIndex, slide: slideCopy, listId }), this.onSlideCreated)
        } else {
          this.$socket.emit('/lists/slides/update', this.tokenize({ slide: slideCopy }), this.onSlideUpdate)
        }
      }
    },
    onSlideCreated: function (response) {
      // console.log('onSlideCreated', response)

      if (response.status.code === 200) {
        const slide = response.data.slide
        // go to route slide/edit, or return
        this.$router.push({ path: `/slide/edit/${slide.listId}/${slide.id}` })
        // this.init(data.results)
        this.init(slide)
      } else {
        alert(response.status)
      }
    },
    onSlideUpdate: function (response) {
      // console.log('onSlideUpdate', response)
      if (response.status.code === 200) {
        const slide = response.data
        // console.log(slide)
        // return ?
        // temporary
        this.init(slide)
      } else {
        console.log('onSlideUpdate error: ', response)
        alert('onSlideUpdate error: ' + response.status.code)
      }
    },
    onValidate: function () {
      // if (this.slide.modules.length < 1) {
      //   this.addValidationError('[Slide] You need to add at least one module')
      // }
      if (!Object.prototype.hasOwnProperty.call(this.slide, 'listId')) {
        this.addValidationError('[Slide] Missing slide.listId')
      }
      if (this.$route.name === 'slide/edit' && this.slide.id !== this.slideId) {
        this.addValidationError('[Slide] you cannot change the slide.id value')
      }
      if (this.slide.listId !== this.listId) {
        this.addValidationError('[Slide] slide.listId does not match the original. you cannot change the listId value')
      }
      if (this.slide.listId.length !== 24) {
        this.addValidationError('[Slide] slide.listId seems to have a wrong format')
      }
      if (this.list === undefined) {
        this.addValidationError('[Slide] slide.listId ' + this.slide.listId + ' does not exist')
      }
    }
  },
  beforeDestroy () {
    // console.log('Slide/Edit - before destroy')
    eventBus.$off('validate', this.onValidate)
    this.slideOrigString = JSON.stringify({ ...this.$config.slides.defaultModel, ...{ dev: { watch: false } } })
    this.slide = JSON.parse(this.slideOrigString)
    // not dirty if changes were not saved:
    this.$store.commit(`${SLIDES_NAMESPACE}/${SYNCED}`, this.listId)
    this.$store.commit(`${SLIDES_NAMESPACE}/${SYNCED}`, this.listId + this.slideId)
  }
}
</script>
